import api from './api';

export async function manageResending(device) {
  try {
      return await api.get(`/device/resend/${device.id}`);
  } catch (error) {
    console.error('Erro ao reenviar:', error);
    throw error;
  }
}
